import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import TTLProxy from "./TTLAsyncProxy";

export default class IndexRoute extends Route {

    render(){

        const proxy = TTLProxy.getInstance();
        if(proxy.isAuthenticated() && !proxy.isSessionExpired(true)){
            return <Redirect to={{ pathname: '/dashboard' }}/>;
        }

        return <Redirect to={{ pathname: '/login' }}/>;
    }

}


// WEBPACK FOOTER //
// ./src/common/IndexRoute.js